<template>
  <div v-if="wasMounted" class="boolean">
    <sc-tooltip v-if="schema.tooltip" type="is-light" position="is-right"
      :label="schema.tooltip">

      <sc-icon size="is-small" icon="info-circle" />
    </sc-tooltip>

    <sc-field class="boolean__field" :label="schema.title" />

    <sc-switch v-model="value[schema.name]" @input="onChange()" />
    
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScSwitch,
  ScField,
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';

const { mapMutations, mapState } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'boolean-field',
  components: {
    ScSwitch,
    ScField,
    ScTooltip,
    ScIcon,
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
    warehouseId: {
      type: Number,
      required: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      wasMounted: false,
    };
  },
  mounted() {
    if (this.schema.default !== undefined) {
      this.value[this.schema.name] = this.schema.default;
    }
    this.syncAppConfig();
    this.wasMounted = true;
  },
  computed: {
    ...mapState(['appConfig']),
  },
  methods: {
    ...mapMutations([
      'setAppConfigField',
    ]),

    validate() {
      return true;
    },

    onChange() {
      this.syncAppConfig();
      this.$root.$emit('config-updated', this.appConfig.config);
      this.$emit('change');
    },

    syncAppConfig() {
      this.setAppConfigField({
        app_config_section: this.schema.app_config_section,
        warehouseId: this.warehouseId,
        fieldName: this.schema.name,
        fieldValue: this.value[this.schema.name],
      });
    },
  },
};
</script>

<style lang='scss'>
.boolean {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.0em;

  &__field{
    width: 90%;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/fields/BooleanField.vue